var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckmarkRoundEdges(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM15.7071 7.26961C16.0976 6.87908 16.0976 6.24592 15.7071 5.85539C15.3166 5.46487 14.6834 5.46487 14.2929 5.85539L8.125 12.0233L5.70711 9.60539C5.31658 9.21487 4.68342 9.21487 4.29289 9.60539C3.90237 9.99592 3.90237 10.6291 4.29289 11.0196L7.41789 14.1446C7.80842 14.5351 8.44158 14.5351 8.83211 14.1446L15.7071 7.26961Z",
    fill: "#00DFBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckmarkRoundEdges);
export default __webpack_public_path__ + "static/media/icon_checkmark-round-edges.9150a5a2dca7ea1fb6ba1e039192f8c1.svg";
export { ForwardRef as ReactComponent };